import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import AboutCourse from "./components/AboutCourse";
import ConsoleFeatures from "./components/ConsoleFeatures";
import TechnicalSpecs from "./components/TechnicalSpecs";
import Modules from "./components/Modules";
import WingApps from "./components/WingApps";
import Bonuses from "./components/Bonuses";
import Instructor from "./components/Instructor";
import Testimonials from "./components/Testimonials";
import Gallery from "./components/Gallery";
import Pricing from "./components/Pricing";
import Guarantee from "./components/Guarantee";
import FAQ from "./components/FAQ";
import LeadForm from "./components/LeadForm";
import DownloadsBanner from "./components/DownloadsBanner";
import Footer from "./components/Footer";
import TrainingIndividual from "./components/TrainingIndividual";
import QuizBanner from "./components/QuizBanner";
import BackToTop from "./components/BackToTop";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import PainPoints from "./components/PainPoints";
import PartnersStrip from "./components/PartnersStrip";
import Deliverables from "./components/Deliverables";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLeadsKanban from "./pages/AdminLeadsKanban";
import AdminQuiz from "./pages/AdminQuiz";
import QuizPage from "./pages/QuizPage";
import Downloads from "./pages/Downloads";
import Sobre from "./pages/Sobre";
import NotFound from "./pages/NotFound";
import SEO from "./components/SEO";
import Analytics from "./components/Analytics";
import VisitTracker from "./components/VisitTracker";
import AdminAnalytics from "./pages/AdminAnalytics";
import AdminBlog from "./pages/AdminBlog";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import AgenteTecnico from "./pages/AgenteTecnico";
import AdminAgente from "./pages/AdminAgente";
import AdminSurveys from "./pages/AdminSurveys";
import Agendar from "./pages/Agendar";
import AdminAgendamentos from "./pages/AdminAgendamentos";
import SolicitarDados from "./pages/SolicitarDados";
import AdminLGPD from "./pages/AdminLGPD";
import ScrollToTop from "./components/ScrollToTop";
import { faqData } from "./data/mock";
import { Toaster } from "./components/ui/sonner";

// JSON-LD: FAQPage usando perguntas reais do FAQ
const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqData.map((f) => ({
    "@type": "Question",
    name: f.question,
    acceptedAnswer: { "@type": "Answer", text: f.answer },
  })),
};

const HomePage = () => {
  return (
    <>
      <SEO
        path="/"
        description="Mentoria híbrida com Adeilson Chagas, endorsee oficial Behringer Brasil. 4 aulas ao vivo + 20 gravadas: roteamento, FX, mixbus, GEQ, monitor, FOH e mais. Nova turma em breve."
        jsonLd={[faqJsonLd]}
      />
      <Hero />
      <PartnersStrip />
      <PainPoints />
      <AboutCourse />
      <ConsoleFeatures />
      <TechnicalSpecs />
      <Modules />
      <QuizBanner />
      <Deliverables />
      <WingApps />
      <Bonuses />
      <Instructor />
      <Testimonials />
      <Gallery />
      <Pricing />
      <Guarantee />
      <FAQ />
      <LeadForm />
      <DownloadsBanner />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Analytics />
      <VisitTracker />
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={
            <>
              <Header />
              <main>
                <HomePage />
              </main>
              <Footer />
              <BackToTop />
            </>
          } />
          <Route path="/treinamento-individual" element={
            <>
              <SEO
                title="Treinamento Individual da Console WING"
                description="Aulas particulares 1-a-1 sobre a Console Behringer WING com Adeilson Chagas. Conteúdo personalizado, ritmo do aluno e suporte direto."
                path="/treinamento-individual"
                breadcrumbs={[{ name: 'Treinamento Individual', path: '/treinamento-individual' }]}
              />
              <TrainingIndividual />
              <Footer />
            </>
          } />
          {/* Admin Routes (não indexar) */}
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={
            <>
              <SEO title="Admin Login" path="/admin/login" noindex />
              <AdminLogin />
            </>
          } />
          <Route path="/admin/dashboard" element={
            <>
              <SEO title="Admin Dashboard" path="/admin/dashboard" noindex />
              <AdminDashboard />
            </>
          } />
          <Route path="/admin/leads" element={
            <>
              <SEO title="Admin Leads" path="/admin/leads" noindex />
              <AdminLeadsKanban />
            </>
          } />
          <Route path="/admin/quiz" element={
            <>
              <SEO title="Admin Quiz" path="/admin/quiz" noindex />
              <AdminQuiz />
            </>
          } />
          <Route path="/admin/analytics" element={
            <>
              <SEO title="Admin Visitas" path="/admin/analytics" noindex />
              <AdminAnalytics />
            </>
          } />
          <Route path="/admin/blog" element={
            <>
              <SEO title="Admin Blog" path="/admin/blog" noindex />
              <AdminBlog />
            </>
          } />
          {/* Blog público */}
          <Route path="/blog" element={
            <>
              <Blog />
              <Footer />
            </>
          } />
          <Route path="/blog/:slug" element={
            <>
              <BlogPost />
              <Footer />
            </>
          } />
          {/* Quiz Route */}
          <Route path="/quiz" element={
            <>
              <SEO
                title="Quiz Console WING — Teste Seu Conhecimento"
                description="Faça o quiz gratuito de 10 perguntas sobre a Console Behringer WING. Receba diagnóstico imediato e card personalizado para compartilhar."
                path="/quiz"
                breadcrumbs={[{ name: 'Quiz Console WING', path: '/quiz' }]}
              />
              <QuizPage />
            </>
          } />
          {/* Downloads — apps, firmwares, drivers */}
          <Route path="/downloads" element={
            <>
              <SEO
                title="Central de Downloads — Apps, Firmwares e Drivers WING"
                description="Baixe gratuitamente apps oficiais, firmwares e drivers USB para Behringer WING Rack, WING Compact e WING Full."
                path="/downloads"
                breadcrumbs={[{ name: 'Downloads', path: '/downloads' }]}
              />
              <Downloads />
              <Footer />
            </>
          } />
          {/* Agendamento de atendimento (público) */}          <Route path="/agendar" element={
            <>
              <SEO
                title="Agende seu Atendimento — WING Academy Brasil"
                description="Agende um atendimento de 10 minutos com a WING Academy Brasil. Escolha o melhor dia e horário disponível."
                path="/agendar"
                noindex
              />
              <Agendar />
            </>
          } />
          {/* Solicitação de dados LGPD (público) */}
          <Route path="/solicitar-dados" element={
            <>
              <SEO
                title="Solicitação de Dados (LGPD) — WING Academy Brasil"
                description="Solicite o acesso ou a exclusão dos seus dados pessoais conforme a LGPD."
                path="/solicitar-dados"
                noindex
              />
              <SolicitarDados />
            </>
          } />
          {/* Privacy Policy / LGPD */}
          <Route path="/politica-de-privacidade" element={
            <>
              <SEO
                title="Política de Privacidade (LGPD)"
                description="Política de Privacidade da WING Academy Brasil em conformidade com a LGPD. Como coletamos, usamos e protegemos seus dados."
                path="/politica-de-privacidade"
                breadcrumbs={[{ name: 'Política de Privacidade', path: '/politica-de-privacidade' }]}
              />
              <PrivacyPolicy />
              <Footer />
            </>
          } />
          {/* Sobre — Adeilson Chagas */}
          <Route path="/agente" element={<AgenteTecnico />} />
          <Route path="/admin/agente" element={<AdminAgente />} />
          <Route path="/admin/pesquisa" element={
            <>
              <SEO title="Admin Pesquisa" path="/admin/pesquisa" noindex />
              <AdminSurveys />
            </>
          } />
          <Route path="/admin/agendamentos" element={
            <>
              <SEO title="Admin Agendamentos" path="/admin/agendamentos" noindex />
              <AdminAgendamentos />
            </>
          } />
          <Route path="/admin/lgpd" element={
            <>
              <SEO title="Admin LGPD" path="/admin/lgpd" noindex />
              <AdminLGPD />
            </>
          } />
          <Route path="/sobre" element={
            <>
              <Sobre />
              <Footer />
            </>
          } />
          {/* 404 — catch-all com noindex (evita soft 404 no Google) */}
          <Route path="*" element={
            <>
              <SEO title="Página não encontrada (404)" path="/404" noindex />
              <NotFound />
            </>
          } />
        </Routes>
        <FloatingWhatsApp />
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
